import { useEffect, useState } from "react";
import api from "../../api/client";
import { formatUSD } from "../../lib/format";

export default function WalletMini() {
    const [w, setW] = useState(null);
    useEffect(() => {
        const load = async () => {
            try { const r = await api.get("/wallet/balance"); setW(r.data); } catch {}
        };
        load();
        const id = setInterval(load, 3000);
        return () => clearInterval(id);
    }, []);
    if (!w) return null;
    const pctLocked = w.deposited > 0 ? Math.min(100, (w.locked / w.deposited) * 100) : 0;
    return (
        <div className="bg-[#0A0A0C] border border-[#1F1F24] rounded-sm px-3 py-2.5 flex items-center gap-3" data-testid="wallet-mini">
            <div>
                <div className="text-[9px] font-mono uppercase tracking-[0.22em] text-zinc-500">Free / Total</div>
                <div className="font-mono text-sm mt-0.5">
                    <span className="text-cyan-400">{formatUSD(w.free)}</span>
                    <span className="text-zinc-600 mx-1.5">/</span>
                    <span className="text-zinc-300">{formatUSD(w.deposited)}</span>
                </div>
            </div>
            <div className="w-24 h-1.5 bg-[#1F1F24] rounded-sm overflow-hidden">
                <div className="h-full bg-amber-400" style={{ width: `${pctLocked}%` }} />
            </div>
        </div>
    );
}
